module.exports = __webpack_public_path__ + "static/media/remove-btn.b1af0cbf.svg";